import { formattedTime } from "@/helperFunctions/formatMsToTime";

export const ScoreCard = ({ place, score }: { place: number; score: any }) => {
  console.log(score);

  const formattedScore = formattedTime(score);

  console.log(score);
  console.log(formattedScore);

  return (
    <section className={`scoreCard scoreCard-${place}`}>
      <p>{formattedScore !== "NAN:NAN:NAN" ? formattedScore : score}</p>
    </section>
  );
};
